<template>
    <otif-modal 
        v-bind:title="confirm_title"
        :value="value" 
        @input="$emit('input', $event)"
        v-bind:noclosebtn="true"
        @shown="onShown">
        <template slot="header">
            <span v-bind:class="icon_class"></span>
            <span>{{confirm_title}}</span>
            <span></span>
        </template>
        <table>
            <tr>
                <p>{{details}}</p>
            </tr>
        </table>
        <template slot="footer">
            <otif-button className=" OTPrimary" @click.native="confirm">OK</otif-button>
            <otif-button className=" OTSecondary" @click.native="no">Cancel</otif-button>
        </template>
</otif-modal>

</template>


<script>

export default {
    data() {
        return {
            details: '',
            confirm_title: '',
            icon_class: '',
            line_color: ''      
        }
    },
    props: ['value'],
    methods: {
        no() {
            this.$emit('input', false);
        },

        confirm() {
            this.$emit('input', false);
            this.$parent.saveConfirmed();
        },

        onShown() {
        }
    }
}
</script>
